import React, { useMemo } from 'react';
import { routes } from 'routes';
import { useLocation } from 'wouter';
import { colors } from 'globalStyle';
import Container from 'components/Container';
import { Title, TextLight } from 'components/Texts';
import { AiOutlineArrowRight } from 'react-icons/ai';
import { getContrastTextColor } from 'util/contrast';
import DefaultBackground from 'assets/bloom-portrait.jpg';
import { Box, IconButton, styled } from '@material-ui/core';

import StyledHollow from './StyledHollow';

export default function CardCategory({
  isDesktop,
  background,
  isMainCategorization,
  color = colors.primary,
  name = 'Categoría de proyectos',
  formatUrl,
}) {
  const [, setRoute] = useLocation();
  const isBigTitle = useMemo(() => name.split(' ').some((word) => word.length >= 10), [name]);
  return (
    <StyledContainer
      color={color}
      isDesktop={isDesktop}
      onClick={() => (formatUrl
        ? setRoute(`${routes.project.categorization.route}${formatUrl}`)
        : setRoute(routes.project.allProjects))}
    >
      <Box
        alt=""
        top={0}
        left={0}
        right={0}
        bottom={0}
        zIndex={-1}
        width="100%"
        height="100%"
        component="img"
        position="absolute"
        borderRadius="inherit"
        src={formatUrl ? background : DefaultBackground}
        style={{
          objectFit: formatUrl && 'cover',
        }}
      />
      <Title
        size={isDesktop ? 24 - (isBigTitle ? 4 : 0) : 20}
        color={getContrastTextColor(color)}
      >
        {name}
      </Title>
      <StyledText
        mt={5}
        size={isDesktop ? 15 : 13}
        color={getContrastTextColor(color)}
      >
        {formatUrl
          ? `Te invitamos a conocer más proyectos de ${isMainCategorization ? 'esta categorización' : 'este aliado'}`
          : 'Te invitamos a conocer más proyectos de diferentes categorías'}
      </StyledText>
      <StyledIconButton
        color={color && getContrastTextColor(color)}
      >
        <AiOutlineArrowRight
          color={getContrastTextColor(color)}
          fontSize={isDesktop ? '26px' : ''}
          strokeWidth={isDesktop ? '3px' : ''}
        />
      </StyledIconButton>
      <StyledText
        isCenter
        mb={isDesktop ? 41 : 12}
        size={isDesktop ? 14 : 14}
        color={getContrastTextColor(color)}
      >
        Ver todos los proyectos
      </StyledText>
      <StyledHollow
        padding="8px 25.5px"
        customColor="transparent"
        hoverColor={colors.WHITE}
        size={isDesktop ? 12 : 12}
        textColor={color && getContrastTextColor(color)}
        borderColor={color && getContrastTextColor(color)}
        hoverColorText={color && getContrastTextColor(color, { defaultDark: color })}
      >
        Invertir
      </StyledHollow>
    </StyledContainer>
  );
}

const StyledContainer = styled(Container)(({ isDesktop, color }) => ({
  cursor: 'pointer',
  color: colors.WHITE,
  borderRadius: '25px',
  position: 'relative',
  background: `${color}c2`,
  padding: '80px 25px 0 25px',
  width: isDesktop ? '184px' : '184px',
  height: isDesktop ? '490px' : '490px',
  '&:hover': {
    background: `${color}d9`,
  },
}));

const StyledText = styled(TextLight)(({ color }) => ({
  color: `${color || colors.WHITE} !important`,
}));

const StyledIconButton = styled(IconButton)(({ color }) => ({
  padding: '16.5px',
  marginTop: '46.5px',
  marginBottom: '10px',
  borderRadius: '100%',
  border: `solid ${color} 3px`,
}));
